<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Workflow Instances" class="px-4 pr-5 mb-5">
      </SimplePageHeader>
      <v-row class="px-5 mb-sm-5">
        <v-col cols="12" sm="4">
          <v-select
            v-model="statusId"
            :items="instanceStatusOptions"
            item-text="name"
            item-value="id"
            label="All Statuses"
            clearable
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="4" class="d-flex align-center">
          <v-btn color="primary" outlined @click="handleSearchClick">Search</v-btn>
          <v-btn class="ml-2" outlined @click="handleClearClick">Clear</v-btn>
        </v-col>
      </v-row>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          dense
          :headers="headers"
          :items="workflowInstanceList"
          class="elevation-2"
        >
          <template v-slot:item.candidateClient="{ item }">
            <span>{{ item.candidateName }}<br><span class="grey--text caption">{{ item.clientName }}</span></span>
          </template>
          <template v-slot:item.statusName="{ item }">
            <v-chip
              x-small
              label
              :color="instanceStatusAttrs(item.statusId).color"
              :dark="instanceStatusAttrs(item.statusId).dark"
            >{{ item.statusName }}</v-chip>
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ item.createdAt | formatDate }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              class="mx-1 my-1"
              color="primary"
              outlined
              @click.prevent="viewInstance($event, item)"
            >
              <v-icon color="primary">visibility</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { BottomSpacer } from '@/components/buttons'
import { SimplePageHeader } from '@/components/pageComponents'
import { workflowInstanceDetailRoute } from '@/lib/constants/routes'
import workflowStatusMixin from './workflowStatusMixin'
import { WORKFLOW_INSTANCE_STATUS_OPTIONS } from '@/lib/constants/workflowStatuses'

export default {
  mixins: [workflowStatusMixin],
  components: {
    BottomSpacer,
    SimplePageHeader
  },
  data () {
    return {
      instanceStatusOptions: WORKFLOW_INSTANCE_STATUS_OPTIONS,
      headers: [
        { text: 'Candidate / Client', value: 'candidateClient', sortable: false, width: '30%' },
        { text: 'Status', value: 'statusName', align: 'center', sortable: false, width: '12%' },
        { text: 'Admin', value: 'adminUserName', sortable: false, width: '15%' },
        { text: 'Created', value: 'createdAt', align: 'center', sortable: false, width: '12%' },
        { text: 'Actions', value: 'action', align: 'center', sortable: false, width: '8%' }
      ]
    }
  },
  computed: {
    ...mapFields('workflowInstances', ['workflowInstanceList']),
    ...mapFields('workflowInstanceFilters', ['statusId'])
  },
  methods: {
    ...mapActions('workflowInstances', ['getWorkflowInstancesWithFilters']),
    ...mapActions('workflowInstanceFilters', ['clearFilters']),
    viewInstance (event, instance) {
      if (event.ctrlKey === true) {
        const route = this.$router.resolve({ name: workflowInstanceDetailRoute.name, params: { id: instance.id } })
        window.open(route.href, '_blank')
      } else {
        this.$router.push({ name: workflowInstanceDetailRoute.name, params: { id: instance.id } })
      }
    },
    handleSearchClick () {
      this.getWorkflowInstancesWithFilters()
    },
    handleClearClick () {
      this.clearFilters()
      this.getWorkflowInstancesWithFilters()
    }
  },
  created () {
    this.clearFilters()
    this.getWorkflowInstancesWithFilters()
  }
}
</script>
